import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={width} height={height}>
      <g fill="none" stroke="#131313" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
        <circle stroke-width="13" cx="193.474" cy="145.427" r="84.634" />
        <circle stroke-width="13" cx="356.391" cy="145.724" r="41.417" />
        <ellipse transform="rotate(-50.885 442.923 179.717)" stroke-width="10" cx="442.935" cy="179.722" rx="38.746" ry="18.128" />
        <path
          stroke-width="13"
          d="M344.67 189.802s-57.468 19.436-60.169 65.354c0 0 24.293 70.928 31.496 83.533 0 0 17.874-10.562 28.757-26.019 10.884-15.456 27.213-50.724 30.528-72.449s11.705-54.921-30.612-50.419zM180.954 280.33c-9.311-18.836-46.534-8.747-58.561 9.187-12.027 17.935-40.894 60.326-68.707 102.956s19.175 70.383 42.894 35.234 55.526-77.865 55.526-77.865 30.218 19.499 49.39 30.454 21.91 1.369 21.91 1.369-33.141-82.5-42.452-101.335zM298 451.912l8.922-3.353c6.819-2.563 10.302-10.239 7.739-17.059l-62.945-167.48c-2.563-6.819-10.239-10.302-17.059-7.739l-8.922 3.353c-6.819 2.563-10.302 10.239-7.739 17.059l62.945 167.48c2.564 6.82 10.24 10.302 17.059 7.739z"
        />
      </g>
    </svg>
  );
};

export default Icon;
